import { supabase } from '@/services/supabase';
import { PublicSummaryPage } from '@/views/summaries/public-summary-page';
import { createFileRoute, redirect } from '@tanstack/react-router';

const BASE_URL = import.meta.env.VITE_API_ALLO_URL;

export const Route = createFileRoute('/share/$shareToken')({
  beforeLoad: async ({ params }) => {
    const { data: session } = await supabase.auth.getSession();
    if (!session.session) {
      return;
    }

    const res = await fetch(`${BASE_URL}/v1/public/summary/${params.shareToken}`);
    if (!res.ok) {
      return;
    }

    const json = await res.json();
    const callId = json.data?.call_id;
    if (!callId) {
      return;
    }

    const accessRes = await fetch(`${BASE_URL}/v1/summary/${callId}`, {
      headers: { Authorization: `Bearer ${session.session.access_token}` },
    });

    if (accessRes.ok) {
      throw redirect({ to: '/', search: { callId, view: 'summaries' } });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { shareToken } = Route.useParams();
  return <PublicSummaryPage shareToken={shareToken} />;
}
